import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { VerificationStatusClassUpdate } from '../../Services/AdsStatusService';
import RejectedUi from '../../pages/Dashboard/RejectedUi/RejectedUi';

const Warning = () => {

    let businessInfoDetails = useSelector(state => state.BusinessInfoReducer?.businessInfo);
    let warningData = businessInfoDetails.warning;
    let adminStatus = useSelector((state) => state.Dashboard?.adminVerificationStatus);

    const [warning, setWarning] = useState({
        title: '',
        content: '',
        adminStatus: '',
        warningStatusClass: '',
    });
    useEffect(() => {
        let warningStatusClass = VerificationStatusClassUpdate(businessInfoDetails?.isProfileApprovedByAdmin)
        let updatedTime = businessInfoDetails?.updated_at;
        function is24HoursPassed(updatedTime) {
            const updatedDate = new Date(updatedTime);
            const currentDate = new Date();
            const timeDifference = currentDate - updatedDate;
            const hoursDifference = timeDifference / (1000 * 60 * 60);
            return hoursDifference >= 24;
        }
        console.log(is24HoursPassed(updatedTime));
        setWarning({
            title: warningData?.title,
            content: warningData?.description,
            adminStatus: adminStatus,
            warningRawStatus: businessInfoDetails?.isProfileApprovedByAdmin,
            warningStatusClass: warningStatusClass,
            successWarningVisibility: is24HoursPassed(updatedTime)
        })
    }, [warningData, adminStatus])

    return (
        // <div className="warning_wrap">
        //     {
        //         !(
        //             warning?.warningStatusClass === 'verification_success' &&
        //             warning?.successWarningVisibility
        //         ) && (
        //             warning?.warningRawStatus === 1 ? (
        //                 <RejectedUi
        //                     type="dashboard"
        //                     className={warning.warningStatusClass}
        //                     title="Profile Verification Successful"
        //                     description="Your profile is now verified!"
        //                 />
        //             ) :
        //                 !warning?.adminStatus && warning?.warningRawStatus === 0 ? (
        //                     <RejectedUi
        //                         type="dashboard"
        //                         className="verification_review"
        //                         title="Profile Verification in Progress"
        //                         description="Your profile is currently under review by our team. This process may take between 24 and 72 hours."
        //                     />
        //                 ) :
        //                     warning?.warningStatusClass && (
        //                         <RejectedUi
        //                             type="dashboard"
        //                             className={warning.warningStatusClass}
        //                             title={warning.title}
        //                             description={warning.content}
        //                         />
        //                     )
        //         )
        //     }


        // </div>
        <div className="warning_wrap">
            {warning?.warning_status === 'rejected' ? (
                <p>No data</p>
            ) : !(
                warning?.warningStatusClass === 'verification_success' &&
                warning?.successWarningVisibility
            ) && (
                warning?.warningRawStatus === 1 ? (
                    <RejectedUi
                        type="dashboard"
                        className={warning.warningStatusClass}
                        title="Profile Verification Successful"
                        description="Your profile is now verified!"
                    />
                ) : warning?.warningRawStatus === 2 ? (
                    <RejectedUi
                        type="dashboard"
                        className={warning.warningStatusClass}
                        title={warning.title}
                        description={warning.content}
                    />
                ) : null
            )}
        </div>

    )
}

export default Warning